/* eslint-disable  react-hooks/exhaustive-deps */
import { getDetails } from '../../api';
import { detailsSet } from '../../store/details/actions';
import { errorNotFound, errorUnauthorized } from '../../store/error/actions';
import LoadingCircle from '../LoadingCircle/LoadingCircle';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

const Initializer = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    const loadDetails = async () => {
      try {
        const detailsResponse = await getDetails(id);

        dispatch(
          detailsSet({
            ...detailsResponse.data,
            isPremium: true,
            isCompany: false,
          })
        );
      } catch (e) {
        const status = e?.response?.status || 404;

        dispatch(status === 404 ? errorNotFound() : errorUnauthorized());
      }

      setTimeout(() => {
        setLoading(false);
      }, 100);
    };

    setLoading(true);
    loadDetails();
  }, []);

  if (loading) {
    return <LoadingCircle />;
  }

  return null;
};

export default Initializer;
